module.exports = __webpack_public_path__ + "images/jobseeker_login_card.svg";